import Vue from 'vue'
import Vuex from 'vuex'
import global from './modules/global'
import user from './modules/user'
import wallet from './modules/wallet'
import counter from './modules/counter.js'
import exchange from './modules/exchange.js'
import order from './modules/order.js'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    global,
    user,
    wallet,
    counter,
    exchange,
    order
  },
  strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/store/index.js